import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ChartData, ChartOptions, Chart, registerables } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ImportsModule } from '../../shared/imports.module';
import { ReportesService } from '../../shared/services/reportes.service';
import { Colaborador, PagoSolicitudReembolso, CalendarioPagoData, Usuario  } from '../../shared/models';
import { finalize, Observable, Subject, takeUntil } from 'rxjs';
import { HomeService } from '../../shared/services/home.service';
import saveAs from 'file-saver';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { ActualizarReportesComponent } from '../../shared/components/actualizar-reportes/actualizar-reportes.component';
import { CatalogosService } from '../../shared/services/catalogos.service';
import { PerfilStore } from '../../shared/store/perfil.store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reportes',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule,
    NzDescriptionsModule, 
    NzIconModule, 
    NzTableModule, 
    NzInputModule, 
    NzButtonModule, 
    NzDatePickerModule,
    NzSelectModule,
    NzPopoverModule,
    BaseChartDirective,
    ImportsModule,
    ActualizarReportesComponent
  ],
  templateUrl: './reportes.component.html',
  styleUrl: './reportes.component.scss'
})
export class ReportesComponent {

  registros: PagoSolicitudReembolso[] = []; 
  registros_colaboradores: Colaborador[] = [];
  registros_colaboradores_filtrados: Colaborador[] = [];
  registrosFiltrados: PagoSolicitudReembolso[] = [];
  fechaInicio: Date | null = null;
  fechaFin: Date | null = null;
  cargandoDatos: boolean = false;
  filtroReportePeriodoPago!: FormGroup;
  MontoSolicitudes : { key: string, value: number}[]=[];
  generarExcel : boolean = false;
  searchText : string | null = null;
  setOfCheckedId = new Set<number>();
  setChecked = new Set<PagoSolicitudReembolso>();
  checked = false;
  indeterminate = false;
  periodos: CalendarioPagoData[] = [];
  isVisible: boolean = false;
  user: Usuario | null = null;
  $onDestroy : Subject<void> = new Subject<void>();
  loadingReportePago : boolean = false;
  loadingReporteBeneficio : boolean = false;
  disabledDate = (current: Date): boolean => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const startOfYear = new Date(currentYear, 0, 1);
    const endOfYear = new Date(currentYear, 11, 31);
    return current < startOfYear || current > endOfYear;
  };

  listOfSelection = [
        {
          text: 'Seleccionar todos los registros',
          onSelect: () => {
            this.onAllChecked(true);
          },
        },
        {
          text: 'Actualizar Estatus',
          onSelect: () => {
            if (this.setChecked.size == 0) {
              this.mustSelectAlert();
            } else {
              this.crearDrawer()
            }
          },
        },
      ];

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        label: 'Montos Aprobados',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 2
      }
    ]
  };

  chartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Montos Aprobados',
        font: {
          size: 18,
          weight: 'bold'
        },
        color: '#262626'
      },
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Meses',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Monto Aprobado (MXN)',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        ticks: {
          callback: function(value) {
            return '$' + Number(value).toLocaleString('es-MX');
          }
        }
      }
    }
  };

  ChartData2: ChartData<'line'> = {
    labels: [],
    datasets: [
      {
        label: 'Beneficio No Ejecutado',
        data: [],
        backgroundColor: 'rgba(102, 138, 255, 0.1)',
        borderColor: '#668AFF',
        borderWidth: 3,
        pointBackgroundColor: '#668AFF',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 8,
        fill: true,
        tension: 0.4
      }
    ]
  };

  ChartOptions2: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Histograma',
        font: {
          size: 18,
          weight: 'bold'
        },
        color: '#262626'
      },
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Meses',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Beneficio No Ejecutado (MXN)',
          font: {
            size: 14,
            weight: 'bold'
          }
        },
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.1)'
        },
        ticks: {
          callback: function(value) {
            return '$' + Number(value).toLocaleString('es-MX');
          }
        }
      }
    }
  };

  constructor(
    private message: NzMessageService,
    private fb: FormBuilder,
    private reportesService: ReportesService,
    private homeService: HomeService,
    private modal: NzModalService,
    private drawerService: NzDrawerService,
    private cdr: ChangeDetectorRef,
    private catalogosService: CatalogosService,
    private sessionStore: PerfilStore,
    private router: Router
  ) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    const hoy = new Date();
    this.fechaInicio = new Date(hoy.getFullYear(), 0, 1);
    this.fechaFin = new Date(hoy.getFullYear(), 11, 31);
    this.obtenerInformacion()
    
  }

  getUser() {
    this.sessionStore.getPerfil()
    .pipe(takeUntil(this.$onDestroy))
    .subscribe((user:Usuario | null) => {
      this.user = user;
      if(!this.user?.esAdmin && !this.user?.esRRHH){
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
      }
      this.obtenerInformacion();
    });
  }

  obtenerInformacion() {
    this.cdr.detectChanges();
    this.obtenerRegistros();
    this.obtenerRegistrosColaboradores();
    this.crearFiltroReportePeriodoPago();
    this.obtenerPeriodos();
  }

  obtenerPeriodos() {
    this.catalogosService.obtenerCatalogoCalendario()
    .pipe(
      takeUntil(this.$onDestroy),
    )
    .subscribe({
      next: (res: any) => {
        this.periodos = res.details as CalendarioPagoData[];
        this.ordenarPeriodosDiciembreAEnero();
      },
      error: (error) => {
        this.message.error('Error al cargar el catálogo de periodos');
      }
    });
  }

   ordenarPeriodosDiciembreAEnero(): void {
    this.periodos.map( periodo => {

      let [yearInicio, monthInicio, dayInicio] = periodo.periodoInicio.toString().split('-').map(Number);
      let [yearFin, monthFin, dayFin] = periodo.periodoFin.toString().split('-').map(Number);
      periodo['periodoInicio'] = new Date(yearInicio, monthInicio - 1, dayInicio);
      periodo['periodoFin'] = new Date(yearFin, monthFin - 1, dayFin);
      return periodo;
    });
  }

  crearFiltroReportePeriodoPago(): void {
    this.filtroReportePeriodoPago = this.fb.group({
      periodo_seleccionado: [null, Validators.required],
      fecha_inicio: [this.fechaInicio, Validators.required],
      fecha_fin: [this.fechaFin, Validators.required],
      search: ['']
    });

    this.filtroReportePeriodoPago.valueChanges.subscribe(() => {
      this.filtrarDatos();
    });
  }

  filtrarDatos(): void {
    const filtros = this.filtroReportePeriodoPago?.getRawValue();
    const fechaInicio = filtros.fecha_inicio;
    const fechaFin = filtros.fecha_fin;
    const search = filtros.search;

    let datosFiltrados = [...this.registros];

    if (fechaInicio && fechaFin) {
      datosFiltrados = datosFiltrados.filter(registro => {
        const fechaRegistro = new Date(registro.fechaPago || '');
        const fechaInicioFiltro = new Date(fechaInicio);
        const fechaFinFiltro = new Date(fechaFin);
        
        fechaRegistro.setHours(0, 0, 0, 0);
        fechaInicioFiltro.setHours(0, 0, 0, 0);
        fechaFinFiltro.setHours(0, 0, 0, 0);
        
        return fechaRegistro >= fechaInicioFiltro && fechaRegistro <= fechaFinFiltro;
      });
    }

    if (search && search.trim() !== '') {
      const searchLower = search.toLowerCase();
      datosFiltrados = datosFiltrados.filter(registro => {
          const nombres = registro.nombres?.toLowerCase() || '';
          const apellidos = registro.apellidos?.toLowerCase() || '';
          const nombreCompleto = `${nombres} ${apellidos}`.toLowerCase();
        return (nombreCompleto.includes(searchLower)) ||
        (registro.estatusSolicitud && registro.estatusSolicitud.toString().toLowerCase().includes(searchLower))
      });
    }
    this.registrosFiltrados = datosFiltrados;
  }

  onPeriodoChange(periodo: CalendarioPagoData): void {
    if (periodo) {
      this.filtroReportePeriodoPago.patchValue({
        fecha_inicio: new Date(periodo.periodoInicio),
        fecha_fin: new Date(periodo.periodoFin)
      });
      
      this.fechaInicio = new Date(periodo.periodoInicio);
      this.fechaFin = new Date(periodo.periodoFin);
    }
    else {
      const hoy = new Date();
      const fechaInicioAño = new Date(hoy.getFullYear(), 0, 1);
      const fechaFinAño = new Date(hoy.getFullYear(), 11, 31);
      
      this.filtroReportePeriodoPago.patchValue({
        fecha_inicio: fechaInicioAño,
        fecha_fin: fechaFinAño
      });
      this.fechaInicio = fechaInicioAño;
      this.fechaFin = fechaFinAño;
    }
  }

  formatearEtiquetaPeriodo(periodo: CalendarioPagoData): string {
    const fechaInicio = new Date(periodo.periodoInicio).toLocaleDateString('es-MX', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    const fechaFin = new Date(periodo.periodoFin).toLocaleDateString('es-MX', {
      day: '2-digit', 
      month: '2-digit',
      year: 'numeric'
    });
    return `${periodo.mesContable} (${fechaInicio} - ${fechaFin})`;
  }

  onFechaInicioChange(fecha: Date): void {
    this.fechaInicio = fecha;
    this.validarFechas();
  }

  onFechaFinChange(fecha: Date): void {
    this.fechaFin = fecha;
    this.validarFechas();
  }

  validarFechas(): void {
    if (this.fechaInicio && this.fechaFin && this.fechaInicio > this.fechaFin) {
      this.message.warning('La fecha de inicio no puede ser mayor que la fecha fin');
    }
  }

  buscarPagos(): void {
    if (!this.fechaInicio || !this.fechaFin) {
      this.message.warning('Por favor seleccione ambas fechas');
      return;
    }

    if (this.fechaInicio > this.fechaFin) {
      this.message.error('La fecha de inicio no puede ser mayor que la fecha fin');
      return;
    }

  }

  obtenerRegistros() {
    this.loadingReportePago = true;
    this.reportesService.obtenerListaReportePeriodoPago()
    .pipe(
      finalize(() => {
        this.loadingReportePago = false;
        this.cdr.detectChanges();
      })
    )
      .subscribe(
        {
          next: (res: any) =>{
            if( res.success ) {
              this.registros = res.details?.pagosSolicitados as PagoSolicitudReembolso[];
              this.registrosFiltrados = [...this.registros];
              this.MontoSolicitudes = res.details?.resumenMensual?.montoAprobadoPorMes;
              this.actualizarGraficoMontosPagados();
            }
            else {
              this.message.error('Error al obtener los registros');
            }
          },
          error: (error) =>{
            console.error(error);
          }
        }
      );
  }

  obtenerRegistrosColaboradores() {
    this.loadingReporteBeneficio = true;
    this.homeService.obtenerListaColaboradores()
    .pipe(
      takeUntil(this.$onDestroy),
      finalize(() => {
        this.loadingReporteBeneficio = false;
        this.cdr.detectChanges();
      }
    )
    )
      .subscribe(
        {
          next: (res: any) => {
            if (res.success) {
              this.registros_colaboradores = res.details as Colaborador[];
              this.registros_colaboradores_filtrados = [...this.registros_colaboradores];
            }
            else {
              this.message.error('Error al obtener los registros');
            }
          },
          error: (error) => {
            console.error(error);
          }
        }
      );
    this.reportesService.obtenerGraficoBeneficioNoEjecutado()
      .subscribe(
        {
          next: (res:any) => {
            if(res.success) {
              let dataGraph = res.details as {key:string, value: number}[];
              this.actualizarGrafico2(dataGraph);
            }
          },
          error: (error) => {
            console.error(error);
          }
        }
      )
  }

  generarExcelBeneficioNoEjecutado() {
    this.descargarExcel( 1 , 'Reporte_Beneficio_No_Ejecutado');
  }

  generarExcelPeriodoPago() {
    this.descargarExcel( 2 , 'Reporte_Periodo_Pago');
  }

  generarExcelIncidencias() {
    this.descargarExcel( 3 , 'Reporte_Incidencias');
  }

  descargarExcel( ServicioExcel : number , FileName : string ) {
    let Service = null;
    switch(ServicioExcel) {
      case 1:
        Service = this.reportesService.generarExcelBeneficioNoEjecutado( null );
        break;
      case 2:
        Service = this.reportesService.generarExcelPeriodoPago(this.filtroReportePeriodoPago?.getRawValue());
        break;
      case 3:
        Service = this.reportesService.generarExcelIncidencias(this.filtroReportePeriodoPago?.getRawValue());
        break;
    }
    if (Service == null) {
      this.message.error('Servicio de Excel no definido');
      return;
    }
    this.generarExcel = true;
    Service
      .pipe(
        finalize(
          ()=>{
            this.generarExcel = false;
          }
        )
      )
      .subscribe({
        next: (res: any) => {
          try {
            if (res) {
              let blob: Blob;
              if (res instanceof Blob) {
                blob = res;
              } else {
                blob = new Blob([res], { 
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
              }
              
              const fecha = new Date();
              const fechaString = fecha.toISOString().split('T')[0];
              const nombreArchivo = `${FileName}_${fechaString}.xlsx`;            
              saveAs(blob, nombreArchivo);
            } else {
              console.error('La respuesta del servidor está vacía');
            }
          } catch (error) {
            console.error('Error al procesar la descarga del Excel:', error);
          }
        },
        error: (error:any) => {
          console.error('Error al generar Excel:', error);
        }
      });
    }

  actualizarGrafico2(dataGraph: {key: string, value: number}[]): void {
    const labels = dataGraph.map(item => item.key);
    const valores = dataGraph.map(item => item.value);
    
    const borderColor = '#668AFF';
    const backgroundColor = 'rgba(102, 138, 255, 0.1)';
    const pointBackgroundColor = '#668AFF';
    
    this.ChartData2 = {
      ...this.ChartData2,
      labels: labels,
      datasets: [
        {
          label: 'Beneficio No Ejecutado',
          data: valores,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 3,
          pointBackgroundColor: pointBackgroundColor,
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          pointRadius: 6,
          pointHoverRadius: 8,
          fill: true,
          tension: 0.4
        }
      ]
    };
  }

  actualizarGraficoMontosPagados(): void {
    if (!this.MontoSolicitudes || this.MontoSolicitudes.length === 0) {
      return;
    }
    const labels = this.MontoSolicitudes.map(item => item.key);
    const valores = this.MontoSolicitudes.map(item => item.value);
    
    const backgroundColors = [
      '#38B2F580',
      '#52c41a80',
      '#fa8c1680',
      '#1890ff80',
      '#722ed180',
      '#eb2f9680',
      '#f5222d80',
      '#faad1480',
      '#13c2c280',
      '#a0d91180',
      '#2f54eb80',
      '#fa541c80'
    ];

    const borderColors = [
      '#38B2F5',
      '#52c41a',
      '#fa8c16',
      '#1890ff',
      '#722ed1',
      '#eb2f96',
      '#f5222d',
      '#faad14',
      '#13c2c2',
      '#a0d911',
      '#2f54eb',
      '#fa541c'
    ];
    
    this.chartData = {
      labels: labels,
      datasets: [
        {
          label: 'Montos Pagados',
          data: valores,
          backgroundColor: backgroundColors.slice(0, labels.length),
          borderColor: borderColors.slice(0, labels.length),
          borderWidth: 2
        }
      ]
    };    
  }

  filtradoNombre($event: any): void {
    const searchValue = this.searchText;    
    if (!searchValue || searchValue.trim() === '') {
      this.registros_colaboradores_filtrados = [...this.registros_colaboradores];
      return;
    }

    const searchTerm = searchValue.toLowerCase().trim();
      this.registros_colaboradores_filtrados = this.registros_colaboradores.filter(colaborador => {
      const numeroEmpleado = colaborador.numeroEmpleado?.toString().toLowerCase() || '';
      const nombres = colaborador.nombres?.toLowerCase() || '';
      const apellidos = colaborador.apellidos?.toLowerCase() || '';
      const nombreCompleto = `${nombres} ${apellidos}`.toLowerCase();
      return numeroEmpleado.includes(searchTerm) || 
             nombres.includes(searchTerm) || 
             apellidos.includes(searchTerm) ||
             nombreCompleto.includes(searchTerm);
    });    
  }

  parseDate( str : string ){
    return new Date(str);
  }

  mustSelectAlert() {
    this.isVisible = true;
  }

    onAllChecked(value: boolean): void {
    this.registrosFiltrados.forEach((item) => this.updateCheckedSet(item!, value));
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.registrosFiltrados.every((item) => this.setChecked.has(item!));
    this.indeterminate =
      this.registrosFiltrados.some((item) => this.setChecked.has(item!)) && !this.checked;
  }

  updateCheckedSet(item: PagoSolicitudReembolso, checked: boolean): void {
    if (checked) {
      this.setChecked.add(item);
    } else {
      this.setChecked.delete(item);
    }
  }

  onItemChecked(item: PagoSolicitudReembolso, checked: boolean): void {
    this.updateCheckedSet(item, checked);
    this.refreshCheckedStatus();
  }

  crearDrawer() {
    const drawer = this.drawerService.create({
      nzContent: ActualizarReportesComponent,
      nzWidth: 720,
      nzPlacement: 'right',
      nzContentParams: {
        reportes: Array.from(this.setChecked).filter( item => item.estatusIdSolicitud != 4) || []
      },
    });

      drawer.afterClose.subscribe({
              next: (res: any) => {
                this.setChecked.clear();
                this.refreshCheckedStatus();
                this.obtenerInformacion();
              },
        });
  }

  getEstatusColor(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
        return '#00A226';
      case 'rechazado':
        return '#E31F42';
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
        return '#0234D7';
      case 'pagado':
        return '#00A226';
      default:
        return '#0234D7';
    }
  }

  getEstatusIcon(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
      case 'pagado':
        return 'assets/icon/success.svg';
      case 'rechazado':
        return 'assets/icon/refuse.svg';
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
      default:
        return 'assets/icon/process.svg';
    }
  }

  handle() {
    this.isVisible = false;
  }

}
